export enum ReportingPeriodSeasons {
  Validation = 'Validation',
  Submission = 'Submission',
  Closed = 'Closed',
}